<template>
    <div>
        <div class="ret1-1">
            <div class="ret1-1-1" @click="backs">历史记录 ></div>
            <div class="ret1-1-1">新刀领用未归还明细</div>
        </div>
        <div class="ret5">
            <div class="ret6">用户信息</div>
            <div class="ret7">
                <div class="ret7-1">用户名称：{{order.username}}</div>
                <div class="ret7-1">订单编号：{{order.code}}</div>
                <div class="ret7-1">领取方式：{{order.paytypeid}}</div>
            </div>
            <div class="ret7">
                <div class="ret7-1">用户编号：{{order.usercode}}</div>
                <div class="ret7-1">三方单号：{{order.paycode}}</div>
                <div class="ret7-1">状态：{{order.state}}</div>
            </div>
            <div class="ret7">
                <div class="ret7-1">领取时间：{{order.ctime}}</div>
                <div class="ret7-1"></div>
                <div class="ret7-1"></div>
            </div>
        </div>
        <div class="ret8">
            <div class="ret6">领取刀具信息表</div>
            <div class="ret9">
                <Table border ref="selection" :columns="columns7" :data="detail" :loading="loading">
                    <template slot-scope="{ row,index }" slot="action">
                        <Button size="small" style="margin-right: 5px;border: none;color: #7AD1F9;" @click="shezhi(row,index)">设置数量</Button> 
                    </template>
                </Table>
            </div>
        </div>
        <div class="ret10" style="border-bottom: none;margin-top: 5px;">
            <Page :total="total" :page-size="7" @on-change="toPage"/>
        </div>
        <div class="ret17">
            <div class="ret17-1" @click="qingchu">清除重输</div>
            <div @click="confires" class="ret17-2">确认归还</div>
        </div>
        <!-- 归还数量 -->
        <xc-model :loading="guiHuanModel" title="归还数量" :is_buttom="false" @cancel="qx">
            <div slot="mbody">
                <div class="ret11">
                    <div class="ret12">
                        <div class="ret13">归还数量：</div>
                        <input v-model="numbers" type="number" placeholder="请输入需要归还的数量" class="ret14">
                    </div>
                    <div class="ret15">
                        <div class="ret16" @click="knows">确认</div>
                        <div class="ret16" style="margin-left: 50px" @click="qx">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
        <!-- 归还确定 -->
        <xc-model :loading="guiHuanSure" title="归还确定" :is_buttom="false" @cancel="cancels">
            <div slot="mbody">
                <div class="ret11">
                    <div class="ret12">
                        <div class="ret13">您确定要将这些刀具进行回收吗？</div>
                    </div>
                    <div class="ret15">
                        <div class="ret16" @click="sure">确认</div>
                        <div class="ret16" style="margin-left: 50px" @click="cancels">取消</div>
                    </div>
                </div>
            </div>
        </xc-model>
    </div>
</template>

<script>
import https from '@/api/retrieve'
    export default {
        inject: ["reload"],
        data(){
            return{
                user:'',
                numbers:'',
                numbers1:'',
                guiHuanModel:false,
                guiHuanSure:false,
                total:0,
                columns7:[
                {
                    title: '刀具名称',
                    width: 200,
                    align: 'center',
                    key: 'goodsname'
                },
                {
                    title: '刀具编码',
                    width: 200,
                    align: 'center',
                    key: 'goodscode'
                },
                {
                    title: '加工产品名称',
                    width: 200,
                    align: 'center',
                    key: 'productname'
                },
                {
                    title: '组织架构',
                    width: 200,
                    align: 'center',
                    key: 'orgname'
                },
                {
                    title: '工序名称',
                    width: 200,
                    align: 'center',
                    key: 'procedurename'
                },
                {
                    title: '刀具型号',
                    width: 200,
                    align: 'center',
                    key: 'goodsmodel'
                },
                {
                    title: '单位',
                    width: 200,
                    align: 'center',
                    key: 'goodsunit'
                },
                {
                    title: '未归还数量',
                    width: 200,
                    align: 'center',
                    key: 'notreturnnum'
                },
                {
                    title: '需要归还的数量',
                    width: 150,
                    align: 'center',
                    key: 'needreturnnum'
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 150,
                    align: 'center'
                }
                ],
                order:{},
                detail:[],
                canList:[],
                dingDanId:'',
                loading:false,
                page:1,
                pageSize:10,
                indexs:'',
                orderid:''
            }
        },
        mounted(){
            this.user = JSON.parse(sessionStorage.getItem('user'));
            this.orderid = this.$route.query.id
            let data = {
                orderid:this.orderid,
                companyid:this.user.companyId,
                page:this.page,
                pageSize:this.pageSize
            }
            https.findorderbyid(data).then(res=>{
                this.detail = res.data.dataList.detail
                this.order= res.data.dataList.order
                this.dingDanId = res.data.dataList.order.id
                this.total = res.data.totalNum
                switch(this.order.paytypeid){
                    case '1':
                    this.order.paytypeid = '支付宝';
                    break;
                    case '2':
                    this.order.paytypeid = '微信'; 
                    break;
                    case '3':
                    this.order.paytypeid = '刷机'; 
                    break;
                }
                switch(this.order.state){
                    case '1':
                    this.order.state = '正常';
                    break;
                    case '2':
                    this.order.state = '出货异常'; 
                    break;
                    case '3':
                    this.order.state = '待出货'; 
                    break;
                    case '4':
                    this.order.state = '取消'; 
                    break;
                }
                this.loading = false
            })
        },
        methods:{
            backs(){
                this.$router.back()
            },
            toPage(e){
                this.loading = true
                let data = {
                    orderid:this.orderid,
                    companyid:this.user.companyId,
                    page:e,
                    pageSize:this.pageSize
                }
                https.findorderbyid(data).then(res=>{
                    this.detail = res.data.dataList.detail
                    this.order= res.data.dataList.order
                    this.dingDanId = res.data.dataList.order.id
                    this.total = res.data.totalNum
                    switch(this.order.paytypeid){
                        case '1':
                        this.order.paytypeid = '支付宝';
                        break;
                        case '2':
                        this.order.paytypeid = '微信'; 
                        break;
                        case '3':
                        this.order.paytypeid = '刷机'; 
                        break;
                    }
                    switch(this.order.state){
                        case '1':
                        this.order.state = '正常';
                        break;
                        case '2':
                        this.order.state = '出货异常'; 
                        break;
                        case '3':
                        this.order.state = '待出货'; 
                        break;
                        case '4':
                        this.order.state = '取消'; 
                        break;
                    }
                    this.loading = false
                })
            },
            shezhi(row,index){
                this.indexs = index
                this.guiHuanModel = true
                this.numbers1 = this.detail[index]
                console.log(this.numbers1,'this.numbers1')
                this.numbers = ''
                // this.canList = []
                // console.log(this.numbers1,'this.numbers1')
            },
            knows(){
                this.$set(this.numbers1,'needreturnnum',this.numbers)
                let data = {
                    id:'',
                    goodsid:'',
                    num:'',
                    price:'',
                    totalprice:'',
                    detailid:''
                }
                data.id = this.numbers1.id
                data.goodsid = this.numbers1.goodsid
                data.num = this.numbers1.needreturnnum
                data.price = this.numbers1.price
                data.totalprice = this.numbers1.totalprice
                data.detailid = this.numbers1.detailid

                // this.canList.push(data)
                if(!this.canList.map(v=>v.id).includes(data.id)){
                    this.canList.push(data)
                }
                this.canList = this.canList.map((v,inx)=>{
                    if(data.id==v.id){
                        v=data
                    }
                    return v
                })
                this.guiHuanModel = false
            },
            qx(){
                this.guiHuanModel = false
            },
            sure(){
                let data = {
                    id:this.dingDanId,
                    details:this.canList
                }
                https.addorderbyorderid(data).then(res=>{
                    if(res.code == '0000'){
                        this.$message.success('回收成功');
                        this.guiHuanSure = false
                        setTimeout(() => {
                            this.reload();
                        }, 500);
                    }else if(res.code == '1002'){
                        this.$message.error('归还内容为空');
                    }else if(res.code == '1111'){
                        this.$message.error('归还内容大于未归还');
                    }
                })
            },
            cancels(){
                this.guiHuanSure = false
            },
            confires(){
                this.guiHuanSure = true
            },
            qingchu(){
                if(this.canList.length == 0) {
                    this.$message.info('你还没有修改值')
                }else {
                    this.canList = []
                    this.$message.success('清除成功,请重新修改')
                    this.loading = true
                    let data = {
                        orderid:this.orderid,
                        companyid:this.user.companyId,
                        page:this.page,
                        pageSize:this.pageSize
                    }
                    https.findorderbyid(data).then(res=>{
                        this.detail = res.data.dataList.detail
                        this.order= res.data.dataList.order
                        this.dingDanId = res.data.dataList.order.id
                        this.total = res.data.totalNum
                        switch(this.order.paytypeid){
                            case '1':
                            this.order.paytypeid = '支付宝';
                            break;
                            case '2':
                            this.order.paytypeid = '微信'; 
                            break;
                            case '3':
                            this.order.paytypeid = '刷机'; 
                            break;
                        }
                        switch(this.order.state){
                            case '1':
                            this.order.state = '正常';
                            break;
                            case '2':
                            this.order.state = '出货异常'; 
                            break;
                            case '3':
                            this.order.state = '待出货'; 
                            break;
                            case '4':
                            this.order.state = '取消'; 
                            break;
                        }
                        this.loading = false
                    })
                }
                // this.canList = []
                // this.$message.success('清除成功,请重新查询')
                // setTimeout(() => {
                //     this.reload();
                // }, 500);
            }
        }
    }
</script>

<style scoped>
.ret1-1{
    height: 30px;
    font-size: 18px;
    display: flex;
    align-content: center;
}
.ret1-1-1{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    cursor: pointer;
}
.ret1-2{
    width: 98%;
    height: 60px;
    background-color: #fff;
    display: flex;
    align-items: center;
}
.ret1{
    height: 44px;
    background-color: #E9EAEC;
    border-radius: 30px;
    padding: 0 20px;
    display: flex;
    width: 300px;
    margin-left: 40px;
    justify-content: space-between;
}
.ret2{
    width: 200px;
    height: 42px;
    border: none;
    font-size: 15px;
    color: #989898;
    background-color: #E9EAEC;
}
.ret3{
    width: 22px;
    height: 22px;
    margin-top: 11px;
    margin-right: 10px;
    cursor: pointer;
}
.ret4{
    width: 120px;
    height: 42px;
    font-size: 18px;
    color: #fff;
    background-color: #2176FA;
    text-align: center;
    line-height: 42px;
    margin-left: 20px;
    cursor: pointer;
}
.ret5{
    width: 98%;
    height: 200px;
    background-color: #fff;
    margin-top: 20px;
}
.ret6{
    width: 98%;
    margin: 0 auto;
    padding: 10px 0;
    font-size: 18px;
    color: #2176FA;
    border-bottom: 1px solid #ccc;
}
.ret7{
    width: 98%;
    display: flex;
    justify-content: space-around;
    font-size: 18px;
    color: #555355;
}
.ret7-1{
    width: 30%;
    padding: 10px 0;
}
.ret8{
    width: 98%;
    height: 600px;
    background-color: #fff;
    margin-top: 20px; 
}
.ret9{
    width: 98%;
    margin: 20px auto 0;
}
.ret10{
    width: 98%;
    background-color: white;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #DDE5F5;
    display: flex;
    justify-content: flex-end;
}
.ret11{
    width: 100%;
}
.ret12{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 60px;
}
.ret13{
    font-size: 18px;
    color: #333333;
    line-height: 44px;
}
.ret14{
    width: 400px;
    height: 44px;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 25%);
    border: none;
    padding: 0 10px;
}
.ret15{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 60px;
    margin-bottom: 30px;
}
.ret16{
    background-color: #2176FA;
    width: 120px;
    height: 40px;
    color: white;
    line-height: 40px;
    font-size: 16px;
    text-align: center;
    border-radius: 20px;
    cursor: pointer;
}
.ret17{
    width: 98%;
    height: 40px;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    font-size: 18px;
    color: #fff;
}
.ret17-1{
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #F35252;
    cursor: pointer;
}
.ret17-2{
    width: 100px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background-color: #2176FA;
    cursor: pointer;
}
</style>